import { Component, HostBinding, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { getFirstError, showError } from '../../validation';
import { Errors } from '../../errors';

@Component({
    selector: 'nom-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorComponent {
  protected readonly getFirstError = getFirstError;

  @Input()
  public control!: FormControl;

  @Input()
  public errors = Errors.defaults;

  @HostBinding('class.input-error')
  public readonly inputErrorClass = true;

  /**
   * Whether to show an error in the UI for this field.
   * @internal
   */
  public get showError(): boolean {
    return showError(this.control) && !!this.errorPresentation;
  }

  /**
   * Get the presentation for the first error to display in this field.
   * @internal
   */
  public get errorPresentation(): string | null {
    if (!this.control) {
      return null;
    }
    const firstError = this.getFirstError(this.control);
    if (firstError) {
      const errorMessage = this.errors[firstError];
      if (typeof errorMessage === 'function') {
        return errorMessage(this.control.getError(firstError));
      } else {
        return errorMessage ?? null;
      }
    }
    return null;
  }
}
